<template>
  <div>
    <div class="centered-header">
      <h4 class="ui header" style="color: #092442;">
        <i class="stethoscope icon"></i>
        <div class="content">
          Medical History
        </div>
      </h4>
    </div>
    <div class="ui divider"></div>
    
    <div v-if="componentDiagnose && componentDiagnose.object">
      <div class="ui raised tall stacked segment" style="white-space: pre-line;">
        {{ componentDiagnose.object.object.diagnose_text }}
      </div>
    </div>

    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          {{ $t('noDiagnoseHaveBeenAddedYet') }}
        </div>
        <div class="ui primary button" style="background-color: #092442"
             @click="showModal()"
             v-if="canAdd">
          {{ $t('addDiagnose') }}
        </div>
      </div>
    </div>

    <div class="ui large longer modal" :id="'diagnose-' + reservationVisitId" style="margin-top: 20px !important;">
      <div class="header">{{ $t('addDiagnose') }}</div>

      <div class="content">
        <div class="ui form">
          <div class="required field">
            <label>{{ $t('diagnose') }}</label>
            <textarea :placeholder="$t('diagnose')" v-model="emptyDiagnose.diagnose_text"></textarea>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui button"
             @click="hideModal()">
          {{ $t('discard') }}
        </div>

        <div class="ui blue button"
             style="background-color: #092442"
             @click="save()">
          {{ $t('save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reservationVisitId: { type: Number, default: null },
    diagnose: { type: Object, default: () => {} },
    canAdd: { type: Boolean, default: false }
  },
  data () {
    return {
      emptyDiagnose: {
        diagnose_text: ''
      },
      componentDiagnose: {}
    }
  },
  mounted () {
    this.componentDiagnose = this.diagnose
  },
  computed: {
  },
  methods: {
    showModal () {
      $('#diagnose-' + this.reservationVisitId).modal('show')
    },
    hideModal () {
      $('#diagnose-' + this.reservationVisitId).modal('hide')
    },
    save () {
      this.$http.post(`reservation_visits/${this.reservationVisitId}/add/diagnose`, {
        diagnose: { object: this.emptyDiagnose },
        clinic_id: this.getClinicId()
      }).then(response => {
        this.componentDiagnose = response.data
        this.hideModal()
      })
    }
  }
}
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/DiagnosePart.vue